import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of, tap } from 'rxjs';
import { HttpCacheService } from './http-cache.service';

const DEFAULT_TTL = 100 * 60 * 1000; //100 minutes
const TTL_HEADER = 'x-cache-ttl';

@Injectable()
export class HttpCacheInterceptor implements HttpInterceptor {
  constructor(private cache: HttpCacheService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    const ttlHeader = req.headers.get(TTL_HEADER);
    const ttl = ttlHeader ? Number(ttlHeader) : DEFAULT_TTL;

    if (Number.isNaN(ttl) || ttl <= 0) {
      return next.handle(req);
    }

    const cacheKey = req.urlWithParams;
    const cachedResponse = this.cache.get(cacheKey);

    if (cachedResponse) {
      return of(cachedResponse.clone()).pipe(delay(250));
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.cache.set(cacheKey, event, ttl);
        }
      }),
    );
  }
}
